import Vue      from 'vue'
import Router   from 'vue-router'
import Reroute  from '@/util/reroute'
import config   from '@/config'

Vue.use(Router)

//import routeAll   from './all'
import routeLeft  from './left'

import routeMainAll   from '@/apps/main/router/all'
import routeMainRight from '@/apps/main/router/right'
   
//const async routeAll  = await 
//const routeLeft = System.import('@/apps/fico/router/left');

let routes = [
  ...Reroute(routeMainAll,   'main'),
  ...Reroute(routeMainRight, 'main'),
  //...Reroute(routeAll,  'antrian'),
  ...Reroute(routeLeft, 'main')
];

let unique = new Map(routes.map(obj => [obj.name, obj]));

export default new Router({
    routes: unique
})
